import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';

import {
  AgCellWrapperComponent,
  ICellWrapperParams,
} from '@shared/ag-components/ag-cell-wrapper/ag-cell-wrapper.component';
import { CheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

import { ForecastTableGridComponent } from '../../forecast-table-grid.component';
import {
  ForecastTableGridDataInterface,
  ForecastTableGridParentComponentContext,
} from '../../models/forecast-table-grid.model';

@Component({
  imports: [IconComponent, CheckboxComponent, TooltipDirective, AsyncPipe],
  selector: 'aux-forecast-table-grid-category',
  styleUrls: ['./forecast-table-grid-category.component.scss'],
  templateUrl: './forecast-table-grid-category.component.html',
})
export class ForecastTableGridCategoryComponent
  extends AgCellWrapperComponent
  implements ICellRendererAngularComp
{
  componentParent!: ForecastTableGridComponent;
  context!: ForecastTableGridParentComponentContext;
  data!: ForecastTableGridDataInterface;
  disableCategory = false;
  params!: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.context = this.params.context;
    this.componentParent = this.context.componentParent;
    this.data = this.params.data;

    if (!this.componentParent.userHasModifyPermissions) {
      this.disableCategory = true;
    }

    this.autoTestAttribute = this.getAutoTestAttribute(params);
  }

  getAutoTestAttribute(params: ICellWrapperParams): string {
    const isTotalCell = params.node.rowPinned === 'bottom';

    const field = params.colDef?.field || '';
    const index = params.rowIndex;

    const fieldName = params.customLocator || field;

    return isTotalCell ? `${fieldName}_total` : `${fieldName}_${index}`;
  }

  refresh(): boolean {
    return false;
  }
}
